<script>
  let file;
  import Loader from '../components/Loader.svelte';
  import { clearUser, getAuthToken } from '../stores/auth';
  import { BASE_URL } from '../components/Helper';
  import { navigate } from 'svelte-routing';
  let isFormPending = false;
  let message = {
    success: '',
    error: '',
  };
  const updateForm = () => {
    isFormPending = true;
    var data = new FormData();
    data.append('file', file.files[0]);
    fetch(BASE_URL + 'api/client/fund-import', {
      headers: {
        Authorization: 'Bearer ' + getAuthToken(),
      },
      method: 'POST',
      body: data,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.errorType != undefined && response.errorType == 'INVALID_ACCESS') {
          window.location = '/invalid-access';
        }
        if (response.status.code == 200) {
          message = response.data;
        } else {
          message = {
            success: '',
            error: response.status.message,
          };
        }
      })
      .finally(() => {
        isFormPending = false;
      });
  };
  import { downloadUrlFile } from 'components/Helper.js';
  import { client } from 'root/api/index.js';
  const downloadCsv = () => {
    client.downloadClientFundSampleCsv().then(async (result) => {
      downloadUrlFile(result.data.fileUrl, result.data.fileName);
    });
  };
</script>

<div class="d-flex h-100 w-100 p-3 flex-column">
  <div class="block-header mb-2">
    <div class="row align-items-center">
      <div class="col-md-7">
        <div class="d-flex flex-row">
          <h2 class="page-title">Client Fund Import</h2>
        </div>
      </div>
      <div class="col-md-5 text-end">
        <button
          on:click={() => navigate('/client')}
          type="button"
          class="mb-0 px-3 font-size-13 btn btn-primary font-size-13 shadow-none px-3"
        >
          Back</button
        >
      </div>
    </div>
  </div>
  <div class="page-content card-content bg-white">
    <div class="d-flex flex-column h-100">
      <div class="page-content card border-0">
        <div class="tab-content d-flex flex-column h-100 p-3">
          <div class="tab-pane page-content fade show active">
            <div class="form-group mb-3 d-flex flex-row justify-content-centerr">
              <div
                class="form-group mb-3 position-relative"
                style="width:300px;"
              >
                {#if isFormPending == false}
                  <input
                    name="file"
                    type="file"
                    accept=".csv"
                    class="form-control"
                    bind:this={file}
                  />
                {/if}
              </div>
              <div
                class="form-group mb-3 position-relative ms-1"
                style="    width: 150px;"
              >
                <button
                  type="button"
                  color="primary"
                  class="btn btn-primary shadow-none background-blue mb-0 text-white add-task px-4 font-size-12"
                  on:click={updateForm}
                  disabled={isFormPending}
                >
                  {#if isFormPending}
                    <Loader />
                  {:else}
                    <span class="color-white font-size-12 font-weight-400"> Import Csv File </span>
                  {/if}
                </button>
              </div>
              <div
                class="form-group mb-3 position-relative ms-1"
                style="    width: 200px;"
              >
                <button
                  type="button"
                  color="primary"
                  class="btn btn-link shadow-none mb-2 mb-3 color-blue font-size-12 border-0 bg-transparent"
                  on:click={downloadCsv}
                >
                  <span class="color-white font-size-12 font-weight-400">
                    <img
                      class="download-icon"
                      alt=""
                      src="/images/download.svg"
                    /> Download Sample Csv
                  </span>
                </button>
              </div>
            </div>
            <div class="form-group mb-3 d-flex flex-column justify-content-center">
              <div>
                <label
                  class="success"
                  for="">{@html message.success}</label
                >
              </div>
              <div>
                <label
                  class="error"
                  for="">{@html message.error}</label
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .error {
    color: red;
  }
  .success {
    color: green;
  }
</style>
